import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/Text';
import { colors, fonts, fontSizes, radii } from '@/constants/theme';

export interface StepNumberProps {
  /** 1-based position. Callers pass `i + 1`, never a pre-formatted string. */
  number: number;
}

/**
 * The ordinal badge on a numbered step. Extracted because the deal
 * explainer and the invite explainer had each grown their own — same idea,
 * different size and inverted colors — and they sit two taps apart, so the
 * mismatch read as sloppy.
 *
 * Tint-on-light rather than solid deep green: these are sequence markers,
 * not emphasis, and a column of solid dark discs competes with the step
 * titles beside them.
 */
export function StepNumber({ number }: StepNumberProps) {
  return (
    <View style={styles.badge}>
      <Text style={styles.text}>{number}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    width: 28,
    height: 28,
    borderRadius: radii.full,
    backgroundColor: colors.accentTint,
    alignItems: 'center',
    justifyContent: 'center',
    // Nudge down so the badge aligns to the first line of a wrapping title
    // rather than floating against the cap height.
    marginTop: 1,
  },
  text: {
    fontFamily: fonts.bodyBold,
    fontSize: fontSizes.sm,
    color: colors.deepGreen,
  },
});
